import { Route } from '@angular/router';
import { UserProfileOverviewComponent } from 'src/app/pages/user/user-profile-overview/user-profile-overview.component';
import { UserProfilePermissionsComponent } from 'src/app/pages/user/user-profile-permissions/user-profile-permissions.component';
import { UserProfileSecurityComponent } from 'src/app/pages/user/user-profile-security/user-profile-security.component';
import { UserProfileSettingsComponent } from 'src/app/pages/user/user-profile-settings/user-profile-settings.component';
import { UserProfileComponent } from 'src/app/pages/user/user-profile/user-profile.component';
import { RoutingID } from '../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const user: Route = {
  path: 'user',
  title: 'nav.userProfile',
  data: {
    breadcrumb: 'nav.userProfile',
    icon: SbIcons.userManagement,
    id: RoutingID.user,
  },
  children: [
    {
      path: '',
      component: UserProfileComponent,
      data: {
        breadcrumb: '',
      },
      children: [
        {
          path: 'user-overview',
          component: UserProfileOverviewComponent,
          title: 'nav.userProfile',
          data: {
            breadcrumb: 'nav.userProfile.overview',
            icon: SbIcons.eye,
            id: RoutingID.userOverview,
          },
        },
        {
          path: 'user-security',
          component: UserProfileSecurityComponent,
          title: 'nav.userProfile',
          data: {
            breadcrumb: 'nav.userProfile.security',
            icon: SbIcons.security,
            id: RoutingID.userSecurity,
          },
        },
        {
          path: 'user-permissions',
          component: UserProfilePermissionsComponent,
          title: 'nav.userProfile',
          data: {
            breadcrumb: 'nav.userProfile.permissions',
            icon: SbIcons.key,
            id: RoutingID.userPermissions,
          },
        },
        {
          path: 'user-settings',
          component: UserProfileSettingsComponent,
          title: 'nav.userProfile',
          data: {
            breadcrumb: 'nav.userProfile.settings',
            icon: SbIcons.settings,
            id: RoutingID.userSettings,
          },
        },
        { path: '', redirectTo: RoutingID.userOverview, pathMatch: 'full' },
      ],
    },
  ],
};
